/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import moment from 'moment-timezone';
import styles from './DayEntry.module.scss';

import {
  Container,
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import TextInput from '../TextInput/TextInput';
import DateInput from '../Datepicker/DateInput';
import Dropdown from '../Dropdown/Dropdown';
import { hourTypeOptions } from '../Dropdown/hourTypeOptions';

const enableSupervisorInitials = `${process.env.REACT_APP_ENABLE_SUPERVISOR_INITIALS}` === 'true'

export type DayEntryProps = {
  dayEntry: any;
  setIsFormValid?: any;
  setShowEntryform?: any;
  setEntryIndex?: any;
  isEditEntry?: boolean;
  setIsUpdateEntry?:any;
  setIsUpdatedDay?:any;
  setPreviousDate?:any;
  entryData?: any;
  setEditEntry?: any;
  tableEntryArray?: any;
  entryIndex?: number;
  weekDays?: any;
  setTableRowsCount?: any;
  basicInfo?: any;
  setEntryData?: any
};

const DayEntry = ({
  dayEntry,
  setIsFormValid,
  setShowEntryform,
  setEntryIndex,
  isEditEntry,
  setIsUpdateEntry,
  setIsUpdatedDay,
  setPreviousDate,
  entryData,
  setEditEntry,
  tableEntryArray,
  entryIndex,
  weekDays,
  setTableRowsCount,
  basicInfo,
  setEntryData,
}: DayEntryProps
) => {
  const dateWorkedInput = document.getElementById('dateWorked');
  const breakDurationField = document.getElementById('breakDurationField')
  const schoolSiteField = document.getElementById('schoolSiteField')
  const [date, setDate] = useState('');
  const [timeIn, setTimeIn] = useState('');
  const [timeOut, setTimeOut] = useState('');
  const [maxTableRowsCount, setMaxTableRowsCount] = useState('');

  const [isDateWorkedEmpty, setIsDateWorkedEmpty] = useState(false)
  const [selectedFieldName, setSelectedFieldName] = useState('')
  const [hourType1, setHourType1] = useState(undefined);
  const [radioValue, setRadioValue] = useState<any>();
  const [submitEntry, setsubmitEntry] = useState(false)
  const [title, setTitle] = useState('')
  const [breakDuration, setBreakDuration] = useState('')
  const [schoolSite, setSchoolSite] = useState('');
  const [incorrectOuttime, setIncorrectOuttime] = useState(false);
  const [initialEntry, setInitialEntry] = useState<any>();

  const reset = () => {
    setShowEntryform(false)
    setEntryIndex(null)
    setEditEntry(false);
  }

  useEffect(() => {
      setTableRowsCount(maxTableRowsCount)
  }, [maxTableRowsCount])

  useEffect(() => {
    if (date) {
      setTitle(weekDays[new Date(date).getDay()]);
    }
  }, [date, isEditEntry])


  useEffect(() => {
    if (submitEntry) {
      const entry = {
        date: new Date(date),
        [title.toLowerCase() + 'TimeIn']: timeIn,
        [title.toLowerCase() + 'TimeOut']: timeOut,
        [title.toLowerCase() + 'FirstBreakDuration']: breakDuration,
        [title.toLowerCase() + 'SchoolSite']: schoolSite,
        [title.toLowerCase() + 'BreakMissed']: radioValue,
        [title.toLowerCase() + 'HoursType1']: hourType1,
      };

      if (date) {
        const timeProps = ['TimeIn', 'TimeOut'];
        for (let i = 0; i < timeProps.length; i++) {
          try {
            const mDate = moment(date, 'MM-DD-YYYY');
            const timeProp = timeProps[i];
            const propName = `${title.toLocaleLowerCase()}${timeProp}`;
            const time = entry[propName];
            if (!time) break;
            const timeParts = time.split(':');
            const hour = parseInt(timeParts[0], 10);
            const minute = parseInt(timeParts[1] || 0, 10);
            const mTime = mDate.clone().set({ hour, minute });
            entry[`${propName}Orig`] = entry[propName];
            entry[propName] = new Date(mTime.format());
          } catch (error) { }
        }
      }

      if (!date && dateWorkedInput) {
        dateWorkedInput.style.borderColor = 'red'
      }


      if (hourType1 === 'sick-day') {
        if (date && timeIn && timeOut && breakDuration && hourType1 && !incorrectOuttime) {
          dayEntry(entry);
          if (enableSupervisorInitials && isEditEntry && hasUpdatedEntry()) {
            setIsUpdateEntry(true);
            setIsUpdatedDay(date);
            setPreviousDate(initialEntry?.previousDate)
          }
          reset()
        }
      } else {
        if (date && timeIn && timeOut && schoolSite && breakDuration && hourType1 && !incorrectOuttime) {
          dayEntry(entry);
          if (enableSupervisorInitials && isEditEntry && hasUpdatedEntry()) {
            setIsUpdateEntry(true);
            setIsUpdatedDay(date);
            setPreviousDate(initialEntry?.previousDate)
          }
          reset()
        }
      }
    }
    // eslint-disable-next-line
  }, [submitEntry]);

  useEffect(() => {
    if (isEditEntry) {
      setTimeIn(moment(entryData[title.toLowerCase() + 'TimeIn']).format('HH:mm'));
      setTimeOut(moment(entryData[title.toLowerCase() + 'TimeOut']).format('HH:mm'));
      setBreakDuration(entryData[title.toLowerCase() + 'FirstBreakDuration']);
      setSchoolSite(entryData[title.toLowerCase() + 'SchoolSite']);
      setHourType1(entryData[title.toLowerCase() + 'HoursType1']);
      setRadioValue(entryData[title.toLowerCase() + 'BreakMissed']);
    }
  }, [entryIndex, title])

  useEffect(() => {
    if (isEditEntry) {
      setDate(entryData.date);
    }
  }, [entryIndex])

  useEffect(() => {
    if (date) {
      if (date && !timeIn && !timeOut) {
        setIsFormValid(false)
      } else if (date && timeIn && !timeOut && incorrectOuttime) {
        setIsFormValid(false)
      } else {
        setIsFormValid(true)
      }
      setIsDateWorkedEmpty(false)
    }

    // else if (!hourType1 || !schoolSite && !breakDuration) {
    //   setIsFormValid(false)
    // }

  }, [date, timeIn, timeOut])

  useEffect(() => {
    setsubmitEntry(false);
    if (dateWorkedInput) {
      if (date) {
        dateWorkedInput.style.borderColor = ''
      }

      if (breakDurationField) {
        breakDurationField.style.borderColor = ''
      }

      if (schoolSiteField) {
        schoolSiteField.style.borderColor = ''
      }
    }

    const inTime = timeIn.replace(':', '');
    const outTime = timeOut.replace(':', '');

    if (timeOut) {
      if (outTime < inTime) {
        setIncorrectOuttime(true)
        setTimeOut('')
      } else {
        setIncorrectOuttime(false)
      }

    }

  }, [
    date,
    timeIn,
    timeOut,
    breakDuration,
    schoolSite,
    hourType1
  ])

  useEffect(() => {
    if (enableSupervisorInitials && isEditEntry && date === entryData?.date) {
      const titleKey = title.toLowerCase();
      setInitialEntry({
        previousDate: entryData.date,
        previousTimeIn: moment(entryData[`${titleKey}TimeIn`]).format("HH:mm"),
        previousTimeOut: moment(entryData[`${titleKey}TimeOut`]).format("HH:mm"),
        previousBreakDuration: entryData[`${titleKey}FirstBreakDuration`],
        previousSchoolSite: entryData[`${titleKey}SchoolSite`],
        previousHourType1: entryData[`${titleKey}HoursType1`],
      });
    }
  }, [entryData, title, date]);

  const hasUpdatedEntry = () => {
    return (
      initialEntry.previousDate !== date ||
      initialEntry.previousTimeIn !== timeIn ||
      initialEntry.previousTimeOut !== timeOut ||
      initialEntry.previousBreakDuration !== breakDuration ||
      initialEntry.previousSchoolSite !== schoolSite ||
      initialEntry.previousHourType1 !== hourType1
    );
  };

  const checkWorkedDate = () => {
    if (date) {
      setIsDateWorkedEmpty(false);
    } else {
      setIsDateWorkedEmpty(true)
    }
  }

  return (
    <Container data-testid="DayEntry" className={styles.DayEntry}>
      <Row>
        <Col>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <DateInput
                name='date'
                maxDate={new Date()}
                date={date}
                required
                tableEntryArray={tableEntryArray}
                onValueChange={(val) => {
                  setDate(val)
                  setsubmitEntry(false)

                  const day = weekDays[new Date(val).getDay()].toLowerCase();
                  const newEntryData = { ...entryData };

                  Object.keys(newEntryData).forEach((key) => {
                    if (key.includes(title.toLowerCase())) {
                      const newKey = key.replace(title.toLowerCase(), day.toLowerCase());

                      newEntryData[newKey] = newEntryData[key];
                      delete newEntryData[key];
                    }
                  });

                  setEntryData({
                    ...newEntryData,
                    date: val
                  });
                }}
                setMaxTableRowsCount={setMaxTableRowsCount}
              />
              {(!date && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please select a date</p>}
            </Col>
            <Col xs={12} md={3} lg={{ span: 3 }}>
              <TextInput
                title="Time In"
                onValueChange={(val) => {
                  setTimeIn(val)
                  setsubmitEntry(false)
                }}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
                placeholder={'HH : MM'}
                type="time"
                isDisabled={!date}
                required={!!date}
                fieldValidation={!!date ? "required" : ''}
                name='timeIn'
                values={timeIn}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'timeIn'}
                isFieldInvalid={(submitEntry && date && !timeIn) ? true : false}
              />
              {isDateWorkedEmpty && selectedFieldName === 'timeIn' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
              {(date && !timeIn && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please select in time</p>}
            </Col>
            <Col xs={12} md={3} lg={{ span: 3 }}>
              <TextInput
                title="Time Out"
                onValueChange={(val) => {
                  setTimeOut(val)
                  setsubmitEntry(false)
                }}
                placeholder={'HH : MM'}
                type="time"
                isDisabled={!date}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName(name)
                }}
                value={timeOut}
                required={!!date}
                fieldValidation={!!date ? "required" : ''}
                name='timeOut'
                values={timeOut}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'timeOut'}
                isFieldInvalid={(date && timeIn && !timeOut && !incorrectOuttime && submitEntry) ? true : false}
              />
              {isDateWorkedEmpty && selectedFieldName === 'timeOut' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
              {(date && timeIn && !timeOut && submitEntry) &&
                <p style={{ color: 'red', fontSize: 12 }}>Please select out time</p>}
              {incorrectOuttime && <p style={{ color: 'red', fontSize: 12 }}>Out time can not be less than in time </p>}
            </Col>
          </Row>
          <div data-testid="MealEntry" className={styles.MealEntry}>
            <Row>
              <Col>
                <TextInput
                  title="Lunch (In Minutes)"
                  id='breakDurationField'
                  required
                  onValueChange={setBreakDuration}
                  values={breakDuration}
                  name="firstBreakDuration"
                  fieldValidation="required"
                  type={'text'}
                  inputMode="numeric"
                  isDisabled={!date}
                  isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'firstBreakDuration'}
                  isFieldInvalid={(date && timeIn && timeOut && !breakDuration && submitEntry) ? true : false}
                  onClick={(name) => {
                    checkWorkedDate()
                    setSelectedFieldName(name)
                  }} />
                {isDateWorkedEmpty && selectedFieldName === 'firstBreakDuration' &&
                  <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
                {(date && timeIn && timeOut && !breakDuration && submitEntry) && <p style={{ color: 'red', fontSize: 12 }}>Please enter break duration</p>}
              </Col>
              <Col>
                <TextInput
                  title="School Site(s)/Location(s)"
                  id='schoolSiteField'
                  required={hourType1 !== 'sick-day'}
                  onValueChange={setSchoolSite}
                  values={schoolSite}
                  name="schoolSite"
                  fieldValidation={`${hourType1 !== 'sick-day' ? 'required' : ''}`}
                  type={'text'}
                  isDisabled={!date}
                  isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'schoolSite'}
                  isFieldInvalid={(date && timeIn && timeOut && breakDuration && !schoolSite && submitEntry && hourType1 !== 'sick-day') ? true : false}
                  onClick={(name) => {
                    checkWorkedDate()
                    setSelectedFieldName(name)
                  }} />
                {isDateWorkedEmpty && selectedFieldName === 'schoolSite' &&
                  <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
                {(date && timeIn && timeOut && breakDuration && !schoolSite && submitEntry && hourType1 !== 'sick-day') &&
                  <p style={{ color: 'red', fontSize: 12 }}>Please enter school site</p>}
              </Col>
            </Row>
          </div>
          <Row>
            <Col xs={12} md={6} lg={6}>
              <Dropdown
                name='hourType1'
                title={'Hours Type'}
                required
                isFieldInvalid={(date && timeIn && timeOut && breakDuration && schoolSite && !hourType1 && submitEntry) ? true : false}
                onValueChange={setHourType1}
                options={hourTypeOptions}
                isDisabled={!date}
                values={hourType1}
                isDateWorkedEmpty={isDateWorkedEmpty && selectedFieldName === 'hourType1'}
                onClick={(name) => {
                  checkWorkedDate()
                  setSelectedFieldName('hourType1')
                }}
              />
              {isDateWorkedEmpty && selectedFieldName === 'hourType1' &&
                <p style={{ color: 'red', fontSize: 12 }}>Please define the date worked</p>}
              {(date && timeIn && timeOut && breakDuration && schoolSite && !hourType1 && submitEntry) &&
                <p style={{ color: 'red', fontSize: 12 }}>Please enter hour type</p>}
            </Col>
          </Row>
          <div style={{ marginTop: 5 }}>
            {tableEntryArray?.length > 0 &&
              < Button
                type='button'
                size='sm'
                variant="danger"
                onClick={(e) => reset()}
                style={{ float: 'right', marginLeft: 10 }}
              >
                Cancel
              </Button>}

            <Button
              type='button'
              size='sm'
              variant="success"
              onClick={(e) => setsubmitEntry(true)}
              style={{ float: 'right' }}
            >
              {isEditEntry ? 'Update' : 'Add'}
            </Button>
          </div>
        </Col>
      </Row>
    </Container >
  );
};

export default DayEntry;
